import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import Pumps from "./Pumps";
const defaultAutos = {
    Branches: [],
};

export default function PumpsCons() {

  const [branch, setBranch] = useState({ id: -1, name: "الكل" });
  const tb = {
    wait: true,
    other: true,
    SafesInv: true,
    UsersA: true,
    Currencies: true,
    Branch: true,
    Pumps: true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms:{
      iempid: sto.empi,
      tname: "pump",
      branch:  branch.id == -1 ? sto.branchi : branch.id 
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch],
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches 
  )
    return <LoadingPage />;

  return (
    <Pumps
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        branch,
        setBranch
      }}
    />
  );
}
